<template>
    <div class="container">
        <div class="container-header">
            <div class="search">
                <div class="search-form">
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('userName') }}</span>
                        <el-input v-model="search.username"
                                  size="mini"
                                  clearable
                                  @change="searchHandle"></el-input>
                    </div>
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('phoneNum') }}</span>
                        <el-input v-model="search.mobile"
                                  size="mini"
                                  clearable
                                  @change="searchHandle"></el-input>
                    </div>
                </div>
                <div class="search-handle">
                    <el-button type="primary"
                               size="mini"
                               @click="searchHandle">{{ $t('search') }}</el-button>
                    <el-button type="primary"
                               size="mini"
                               @click="emptyHandle">{{ $t('empty') }}</el-button>
                </div>
            </div>
        </div>
        <div class="container-main">
            <el-table :data="tableData"
                      border
                      style="width: 100%">
                <el-table-column type="index"
                                 align="center"
                                 width="60"></el-table-column>
                <el-table-column min-width="260"
                                 :label="$t('employeeInfo')">
                    <template slot-scope="scope">
                        <div class="info">
                            <el-image :src="scope.row.avatar">
                                <div slot="error"
                                     class="image-slot">
                                    <img src="../../assets/images/logo.png"
                                         alt="">
                                </div>
                            </el-image>
                            <div class="desc avatar-desc">
                                <p class="desc-item">{{ scope.row.username }}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="email"
                                 :label="$t('email')"
                                 align="center"
                                 width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="mobile"
                                 :label="$t('phoneNum')"
                                 align="center"
                                 width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="birthday"
                                 :label="$t('birthday')"
                                 align="center"
                                 width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column :label="$t('creationTime')"
                                 align="center"
                                 width="180">
                    <template slot-scope="scope">
                        <span>{{ scope.row.createdAt | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('whetherEnable')"
                                 align="center"
                                 width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.enabled">{{ $t('yes') }}</span>
                        <span v-else>{{ $t('no') }}</span>
                    </template>
                </el-table-column>
                <el-table-column class-name="handle"
                                 :label="$t('handle')"
                                 align="center"
                                 fixed="right"
                                 width="180">
                    <template slot-scope="scope">
                        <el-button type="text"
                                   size="mini"
                                   @click="enableHandle(scope.row.id)"
                                   v-permission="['user:user-update']"
                                   v-if="!scope.row.enabled">{{ $t('enable') }}
                        </el-button>
                        <el-button type="text"
                                   size="mini"
                                   @click="disableHandle(scope.row.id)"
                                   v-permission="['user:user-update']"
                                   v-else>{{ $t('disenable') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background
                           :current-page="currentPage"
                           layout="sizes, prev, pager, next, total"
                           :page-sizes="[10, 15, 20, 50, 100]"
                           :page-size="pageSize"
                           :total="total"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { queryUserList, userDisable, userEnable } from "@/api/modules/api";

export default {
    name: "UserList",
    // 组件
    components: {

    },
    props: {},
    data () {
        return {
            search: {
                username: '',
                mobile: ''
            },
            tableData: [],
            currentPage: 1,
            total: 0,
            pageSize: 10,
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取数据列表
        getListData () {
            const params = {
                username: this.search.username.trim(),
                mobile: this.search.mobile.trim(),
                page: this.currentPage,
                size: this.pageSize
            }
            queryUserList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 搜索
        searchHandle () {
            // 当前页码初始化
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 清空
        emptyHandle () {
            this.search = {
                username: '',
                mobile: ''
            }
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 切换页码
        handleCurrentChange (page) {
            // 设置页码
            this.currentPage = page
            // 获取列表数据
            this.getListData()
        },
        // 切换显示条数
        handleSizeChange (size) {
            // 设置大小
            this.pageSize = size
            // 初始化页码
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 启用
        enableHandle (id) {
            this.$confirm(this.$t('enableUserHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                let params = {
                    id
                }
                userEnable(params).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => { })
        },
        // 禁用
        disableHandle (id) {
            this.$confirm(this.$t('disableUserHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                let params = {
                    id
                }
                userDisable(params).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => { })
        },
    },
    // 创建完成
    created () {
    },
    // 挂载完成
    mounted () {
        // 获取列表数据
        this.getListData()
    },
    // 销毁之前
    beforeDestroy () {
    },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/base-column.scss';
</style>
